import { Box, Button, Tooltip, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { primarySoft } from '../../../../../../theme';
import VersoBlockEditor from './VersoBlockEditor';
import { MAX_VERSO_BLOCKS, VersoBlock, newVersoBlock } from './versoBlocks';

interface VersoBlocksPanelProps {
  blocks: VersoBlock[];
  onChange: (update: (blocks: VersoBlock[]) => VersoBlock[]) => void;
}

function VersoBlocksPanel({ blocks, onChange }: VersoBlocksPanelProps) {
  const isFull = blocks.length >= MAX_VERSO_BLOCKS;

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
        <Typography variant="body2" fontWeight={700} sx={{ color: 'primary.main', fontSize: '0.85rem' }}>
          Modifier le verso de la carte :
        </Typography>
        <Tooltip title={isFull ? `Maximum ${MAX_VERSO_BLOCKS} blocs` : 'Ajouter un bloc'}>
          <span>
            <Button
              size="small"
              startIcon={<AddIcon fontSize="small" />}
              disabled={isFull}
              onClick={() => onChange(prev => (prev.length >= MAX_VERSO_BLOCKS ? prev : [...prev, newVersoBlock()]))}
              sx={{
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '0.78rem',
                color: 'primary.main',
                borderColor: 'primary.main',
                border: '1px solid',
                borderRadius: 1.5,
                px: 1.25,
                py: 0.4,
                '&:hover': { backgroundColor: theme => primarySoft(theme, 0.06) },
                '&.Mui-disabled': { opacity: 0.4 },
              }}
            >
              Ajouter un bloc
            </Button>
          </span>
        </Tooltip>
      </Box>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.5, fontSize: '0.75rem' }}>
        Si vous ajoutez des blocs (3 blocs maximum), ceux-ci viendront s&apos;ajouter aux blocs initiaux de la carte.
      </Typography>

      {blocks.length === 0 && (
        <Box sx={{ border: '1px dashed', borderColor: 'divider', borderRadius: 1.5, p: 2, textAlign: 'center', backgroundColor: 'grey.50' }}>
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.78rem' }}>
            Aucun bloc ajouté. Cliquez sur « Ajouter un bloc » pour commencer.
          </Typography>
        </Box>
      )}

      {blocks.map((block, index) => (
        <VersoBlockEditor
          key={block.id}
          block={block}
          position={index + 1}
          onChange={patch => onChange(prev => prev.map(b => (b.id === block.id ? { ...b, ...patch } : b)))}
          onRemove={() => onChange(prev => prev.filter(b => b.id !== block.id))}
        />
      ))}
    </>
  );
}

export default VersoBlocksPanel;
